import { makeStyles } from '@material-ui/core';
import themes from 'styles/themes';

export const useStyles = makeStyles((theme) => ({
    fieldLabel: {
        fontFamily: 'PoppinsRegular',
        fontWeight: 600,
        fontSize: '16px',
    },
    fieldContainer: {
        marginBottom: '24px',
        marginTop: '10px',
    },
    textField: {
        width: '100%',
        fontSize: 16,
    },
    customTextField: {
        '& .MuiInputBase-root': {
            fontFamily: 'PoppinsRegular',
        },
        '& .MuiInput-underline': {
            '&.Mui-focused': {
                bottom: 0,
                borderBottom: 'none',
            },
            '&:before': {
                borderBottom: `1px solid ${themes.palette.grey['300']} !important`,
            },
            '&:after': {
                borderBottom: 'none',
            },
        },
    },
}));
